/**
 * The shared look of a form control.
 *
 * One string rather than one per component, because an input, a textarea and a
 * select trigger are the same object at different heights and a reader notices
 * immediately when they are not. It is exported so a control this kit does not
 * ship yet can still be built to match.
 *
 * TWO CHOICES HERE ARE LOAD-BEARING RATHER THAN COSMETIC.
 *
 * `text-body` is 16px, and that is the smallest size iOS Safari will focus
 * without zooming the page. A 14px control is the usual cause of "the form
 * jumps when I tap it" on a phone, and the zoom does not undo itself.
 *
 * `h-11` is 44px, the design's `--size-tap-min`. Anything shorter is below the
 * minimum tap target the design sets out (US-00-005.14).
 *
 * THE RESTING BORDER IS `border-interactive`, NOT `border`, and that is an
 * accessibility fix rather than a preference. `--color-border` is the
 * decorative rule this design uses between rows and around cards. Even after
 * the contrast revision it sits at 2.02:1 light and 2.00:1 dark against the
 * sheet — right for a rule, short of what WCAG 1.4.11 asks of a control's
 * visual boundary, because that boundary is the only thing telling somebody
 * where they may type.
 *
 * The design already ships the right token for this and even records the
 * number beside it: `--color-border-interactive` is #786d5f, annotated in
 * tokens.css as 4.86:1 on surface. It was being spent on `focus-visible`
 * alone, which is the one state where a 2px ring is already shouting. So the
 * strong border is the resting state now, and focus keeps the ring.
 *
 * A DISABLED control drops back to `border-border`. It is exempt from 1.4.11
 * for the same reason its text is exempt from 1.4.3, and the quieter edge is
 * what makes "you cannot type here" legible at a glance.
 */
export const controlClasses =
	"w-full rounded-control border-border-interactive bg-input text-body text-foreground placeholder:text-muted border px-3 py-2 outline-none transition-colors focus-visible:border-border-interactive focus-visible:ring-2 focus-visible:ring-ring/40 disabled:cursor-not-allowed disabled:border-border disabled:bg-input-disabled disabled:text-disabled aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/30"
